import * as React from "react"
const SvgColumns = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15 19.854V5.86l.002-.002.001-.002h3.994l.001.002.002.002v13.993l-.002.002-.001.001h-3.994l-.001-.002zm-10 0V5.86l.002-.002.001-.002h3.994l.001.002L9 5.86v13.993l-.002.002-.001.001H5.003l-.001-.002zm8.588 1.416q.587.587 1.412.587h4q.824 0 1.413-.587A1.93 1.93 0 0 0 21 19.857v-14q0-.824-.587-1.412A1.93 1.93 0 0 0 19 3.857h-4q-.825 0-1.412.588A1.93 1.93 0 0 0 13 5.857v14q0 .825.588 1.413m-10 0q.587.587 1.412.587h4q.825 0 1.412-.587.588-.588.588-1.413v-14q0-.824-.588-1.412A1.93 1.93 0 0 0 9 3.857H5q-.824 0-1.413.588A1.93 1.93 0 0 0 3 5.857v14q0 .825.587 1.413Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgColumns
